/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Emailtemplate_Saveerror3Inputs */

const en_coinvestments_emailtemplate_saveerror3 = /** @type {(inputs: Coinvestments_Emailtemplate_Saveerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save email template`)
};

/**
* | output |
* | --- |
* | "Failed to save email template" |
*
* @param {Coinvestments_Emailtemplate_Saveerror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_emailtemplate_saveerror3 = /** @type {((inputs?: Coinvestments_Emailtemplate_Saveerror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Emailtemplate_Saveerror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_emailtemplate_saveerror3(inputs)
});
export { coinvestments_emailtemplate_saveerror3 as "coInvestments_emailTemplate_saveError" }